import { Head, Link } from '@inertiajs/react'
import Form from './Form'

export default function Edit({ product }) {
  return (
    <>
      <Head title='Editing product' />

      <div className='mx-auto md:w-2/3 w-full px-8 pt-8'>
        <h1 className='font-bold text-4xl'>Editing product</h1>

        <Form
          product={product}
          onSubmit={(form) => {
            form.transform((data) => ({ product: data }));
            form.patch(`/dashboard/products/${product.id}`);
          }}
          submitText='Update Product'
        />

        <div className='flex gap-2 items-center md:justify-center my-3'>
        <Link
          href={`/products/${product.id}`}
          className='bg-[var(--color-yellow-primary)] text-gray-800 font-body font-bold  hover:bg-[var(--color-yellow-secondary)] rounded-full py-1 px-3 shadow-lg transition duration-300 ease-in-out transform hover:-translate-y-1'
        >
          Show this product
        </Link>
        <Link
          href='/products'
          className='bg-[var(--color-yellow-primary)] text-gray-800 font-bold  hover:bg-[var(--color-yellow-secondary)] rounded-full font-body py-1 px-3 shadow-lg transition duration-300 ease-in-out transform hover:-translate-y-1'
        >
          Back to products
        </Link>
        </div>
      </div>
    </>
  );
}
